import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    height: "100%",
    overflow: "hidden",
    overflowY: "hidden",
    flex: 1
  },
  flex: {
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
    alignItems: "center"
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    margin: 8
  },
  resetButton: {
    border: "solid 1px #005F87",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
    borderRadius: 2,
    color: "#005F87",
    height: 32,
    "&:hover": {
      backgroundColor: "#DAECF0",
      boxShadow: "0px 1px 6px 0px rgba(0, 0, 0, 0.3)",
      borderColor: "#005F87"
    },
    "&:active": {
      backgroundColor: "#CDE6EB",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
      borderColor: "#005F87"
    },
    "&:focus": {
      outline: "solid 2px #0F789B",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
      outlineOffset: 2
    }
  },
  applyButton: {
    marginLeft: 8,
    color: "#ffffff",
    backgroundColor: "#005F87",
    border: "solid 1px #003750",
    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
    borderRadius: 2,
    height: 32,
    "&:hover": {
      backgroundColor: "#004D73",
      boxShadow: "0px 1px 6px 0px rgba(0, 0, 0, 0.3)"
    },
    "&:active": {
      backgroundColor: "#003750",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)"
    },
    "&:focus": {
      outline: "solid 2px #0F789B",
      backgroundColor: "#005F87",
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.3)",
      outlineOffset: 2
    }
  },
  commandBar: {
    width: 60,
    backgroundColor: "#F0F0F0",
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    borderLeft: "solid 1px rgba(0, 0, 0, 0.15)",
    boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.3)",
    padding: "7px 7px 7px 3px"
  },
  button: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    color: "rgba(70, 70, 70, 1)",
    cursor: "pointer",
    marginBottom: 8,
    borderTop: "solid 2px transparent",
    "&:hover": {
      backgroundColor: "rgba(218, 236, 240, 1)",
      borderTop: "solid 2px rgba(102, 200, 222, 1)"
    },
    "&:focus": {
      outline: "solid 2px rgba(15, 120, 155, 1)",
      backgroundColor: "rgba(205, 230, 235, 1)"
    }
  },
  selectedButton: {
    backgroundColor: "rgba(218, 236, 240, 1)",
    borderTop: "solid 2px rgba(102, 200, 222, 1)"
  },
  icon: {
    height: 24,
    width: 24,
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  label: { fontSize: 10, fontWeight: 600, fontFamily: "Segoe UI" },
  disabled: {
    color: "rgba(0, 0, 0, 0.3)",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: 8
  },
  disabledColor: {
    color: "rgba(0, 0, 0, 0.3)"
  },
  errorMessage: {
    backgroundColor: "#FBEEED",
    border: "1px solid #FFADAD",
    padding: "3px 5px",
    color: "#DC0000",
    fontSize: 12,
    fontWeight: 400,
    borderRadius: 3,
    display: "flex",
    alignItems: "center",
    gap: 5
  }
}));
